import { atom } from 'jotai';

export type AuthData = {
  id: string;
  email: string;
  name: string;
  customerId: string;
  masterCustomerId: string;
  cmpOrgSsoId: string;
  productScope: string;
  productId: string;
  operations: Array<{
    name: string;
    allowed: boolean;
  }>;
  connectedOpalInstanceId: string;
  accessToken: string;
  instanceId: string;
};

export type OpalAuth = {
  create: (
    instanceId: string,
    initialAccessToken?: string,
    getAccessToken?: () => Promise<string | null>
  ) => OpalAuth;
  initAuth: () => Promise<void>;
  getAuthData: () => AuthData | undefined;
  logout: () => Promise<void>;
};

export const opalAuthAtom = atom<OpalAuth>();
